export default __webpack_public_path__ + "static/media/logo_footer.c9783fd5.svg";